// extracted by mini-css-extract-plugin
export default {"mainForm":"register_mainForm__lwX3u","inputs":"register_inputs__CZhm-","privacy":"register_privacy__OxXbo","warning":"register_warning__A+NGD","confirm":"register_confirm__rK-pG"};